// The optional, unticked "send me news and offers from {practice}" box on every booking and
// client checkout (components/consent/MarketingOptIn.jsx), and the client's own email
// preferences on the account page (public/PortalEmailPreferences.jsx).
export const MARKETING_OPT_IN = {
	// One box per form; `form` is the backend's opt-in form name
	// (modules/crm/consent.OPT_IN_FORMS): booking, consult, product, program, pack, course.
	checkbox: (form) => `marketing-opt-in-${form}`,
	portalSection: 'portal-email-preferences',
	portalStatus: 'portal-email-preferences-status',
	portalOptIn: 'portal-email-preferences-opt-in',
	portalOptOut: 'portal-email-preferences-opt-out',
	portalError: 'portal-email-preferences-error',
};
